<template>
  <div class="AgentOrderListViewContainer">
    <nut-menu scroll-fixed>
      <nut-menu-item v-model="search.categoryId" :options="categories" @change="doSearchAndGoods"/>
      <nut-menu-item v-model="search.goodId" :options="goods" @change="doSearch"/>
      <nut-menu-item v-model="search.agentId" :options="agentIds" @change="doSearch"/>
      <nut-menu-item v-model="search.refund" :options="refundOptions" @change="doSearch"/>
    </nut-menu>
    <nut-searchbar placeholder="昵称、手机号、地址、订单号等"
                   @clear="doSearch"
                   v-model="search.search" clearable class="mt12">
      <template v-slot:rightout>
        <img src="https://cdn.waityou.online/53677ef3-7226-1f76-8b85-eec5aad8ea34.svg"
             class="sqr18" @click="moreSearch=true"/>
      </template>
      <template v-slot:rightin>
        <nut-button type="primary" size="mini" @click="doSearch">搜索</nut-button>
      </template>
    </nut-searchbar>
    <nut-row class="pd16 box">
      <InfiniteLoadingList :query-id="3" :init-query="search" ref="orderList">
        <template v-slot="data">
          <AgentSaleOrderCard :data="data.data" @click="$router.push('/sale/agent/order/detail/'+data.data.id)"/>
        </template>
      </InfiniteLoadingList>
    </nut-row>
  </div>
  <nut-popup position="right" :style="{ width: '90%', height: '100%' }"
             v-model:visible="moreSearch">
    <nut-row class="colFlex pd16 box">
      <span class="ft14">时间范围</span>
      <nut-row class="leftCenter ft12 mt8">
        <div style="width: 160px;background:#f6f7f9;" class="vpd6 bothCenter brd20"
             @click="beginTimeVisible=true">
          <span>{{ search.dateBegin ? search.dateBegin : '开始时间' }}</span>
        </div>
        <span class="opd4">~</span>
        <div style="width: 160px;background:#f6f7f9;" class="vpd6 bothCenter brd20"
             @click="endTimeVisible=true">
          <span>{{ search.dateEnd ? search.dateEnd : '结束时间' }}</span>
        </div>
      </nut-row>
      <nut-radiogroup v-model="search.fastDateRange" direction="horizontal" class="mt10">
        <nut-radio shape="button" label="1">今日</nut-radio>
        <nut-radio shape="button" label="2">昨日</nut-radio>
        <nut-radio shape="button" label="3">本周</nut-radio>
        <nut-radio shape="button" label="4">近3个月</nut-radio>
        <nut-radio shape="button" label="5">近1年</nut-radio>
      </nut-radiogroup>

      <nut-row class="bothCenter wd100 mt30">
        <nut-col :span="12" class="leftCenter">
          <nut-button style="width: 90%" @click="resetMoreSearch">重置</nut-button>
        </nut-col>
        <nut-col :span="12" class="rightCenter">
          <nut-button style="width: 90%" type="primary" @click="doSearch">完成</nut-button>
        </nut-col>
      </nut-row>
    </nut-row>
  </nut-popup>

  <nut-datepicker
      title="开始时间选择"
      type="datetime"
      v-model="dateBegin"
      @confirm="confirmBeginTime"
      :three-dimensional="false"
      v-model:visible="beginTimeVisible"
  ></nut-datepicker>

  <nut-datepicker
      title="结束时间选择"
      v-model="dateEnd"
      type="datetime"
      :three-dimensional="false"
      @confirm="confirmEndTime"
      v-model:visible="endTimeVisible"
  ></nut-datepicker>

  <nut-tabbar @tab-switch="tabSwitch" style="position: fixed;bottom: 0" v-model:visible="actived">
    <nut-tabbar-item tab-title="首页" icon="home"></nut-tabbar-item>
    <nut-tabbar-item tab-title="订单" icon="category"></nut-tabbar-item>
    <nut-tabbar-item tab-title="我的" icon="my"></nut-tabbar-item>
  </nut-tabbar>
</template>

<script>
import AgentSaleOrderCard from "@/components/sale/AgentSaleOrderCard";
import InfiniteLoadingList from "@/components/InfiniteLoadingList";
import api from "@/api";
import {Dialog,} from "@nutui/nutui";

export default {
  name: "AgentOrderListView",
  components: {InfiniteLoadingList, AgentSaleOrderCard},
  data() {
    return {
      dateBegin: null,
      dateEnd: null,
      beginTimeVisible: false,
      endTimeVisible: false,
      moreSearch: false,
      actived: 1,
      search: {
        agentId: 0,
        categoryId: 0,
        goodId: 0,
        search: null,
        dateBegin: null,
        dateEnd: null,
        fastDateRange: 0,
        refund: false,
      },
      refundOptions: [{
        text: '全部订单',
        value: false,
      }, {
        text: '仅退款单',
        value: true,
      }],
      agentIds: [],
      goods: [],
      categories: [],
    }
  },
  methods: {
    doSearchAndGoods() {
      this.moreSearch = false;
      this.$refs.orderList.refresh();
      this.searchGoodsByCategory();
    },
    doSearch() {
      this.moreSearch = false;
      this.$refs.orderList.refresh()
    },
    confirmBeginTime(a) {
      let date = a.selectedOptions.slice(0, 3).map((op) => op.text).join('-');
      let time = a.selectedOptions.slice(3).map((op) => op.value).join(':');
      this.search.dateBegin = date + ' ' + time + ':00'
    },
    confirmEndTime(a) {
      let date = a.selectedOptions.slice(0, 3).map((op) => op.text).join('-');
      let time = a.selectedOptions.slice(3).map((op) => op.value).join(':');
      this.search.dateEnd = date + ' ' + time + ':00'
    },
    resetMoreSearch() {
      this.search.fastDateRange = 0;
      this.search.dateBegin = null;
      this.search.dateEnd = null;
    },
    tabSwitch(item, index) {
      if (index == 0) {
        this.$router.push('/sale/');
      } else if (index == 1) {
        this.$router.push('/sale/agent/order/list');
      } else if (index == 2) {
        this.$router.push('/sale/agent/dashboard');
      }
    },
    init() {
      this.dateBegin = new Date()
      this.dateEnd = new Date()
      api.getUserInfo()
          .then(ret => {
            if (ret.phone) {
              return
            }
            Dialog({
              title: '您未绑定手机号',
              content: '为了更好的服务推荐立即绑定手机号',
              cancelText: '下次吧',
              okText: '好的',
              onCancel: () => {

              },
              onOk: () => {
                this.$router.push('/fill/user/info');
              }
            });
          })
      api.getSaleCategory()
          .then(ret => {
            let categories = [{
              text: '全部类目',
              value: 0,
            }]
            for (let g of ret) {
              categories.push({
                text: g.label,
                value: g.value
              })
            }
            this.categories = categories;
            console.log('categories', categories)
          })
      api.getAgentList()
          .then(ret => {
            let agentIds = [{
              text: '全部团长',
              value: 0,
            }]
            for (let a of ret) {
              agentIds.push({
                text: a.label,
                value: a.value,
              })
            }
            this.agentIds = agentIds;
          });
      this.searchGoodsByCategory()
    },
    searchGoodsByCategory() {
      api.getGoodList4Select(this.search)
          .then(ret => {
            this.search.goodId = 0;
            let goods = [{
              text: '全部商品',
              value: 0,
            }]
            for (let g of ret) {
              goods.push({
                text: g.label,
                value: g.value
              })
            }
            this.goods = goods;
          })
    }
  },
  mounted() {
    this.init()
    document.title = '销售订单列表'
  }
}
</script>

<style lang="scss" scoped>
.AgentOrderListViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>